// ============================================================
// NETWORK CONFIG
// ------------------------------------------------------------
// Change ACTIVE_NETWORK to 'mainnet' or 'testnet' to switch.
// The UI NEVER exposes which network is active — this is the
// only place it is decided.
// ============================================================

export const ACTIVE_NETWORK = 'testnet'; // 'mainnet' | 'testnet'

export const NETWORKS = {
  mainnet: {
    chainId: 56,
    chainIdHex: '0x38',
    name: 'BNB Smart Chain',
    rpcUrls: [
      'https://bsc-dataseed.binance.org',
      'https://bsc-dataseed1.defibit.io',
      'https://bsc-dataseed1.ninicoin.io',
    ],
    blockExplorerUrls: ['https://bscscan.com'],
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
  },
  testnet: {
    chainId: 97,
    chainIdHex: '0x61',
    name: 'BNB Smart Chain',
    rpcUrls: [
      'https://data-seed-prebsc-1-s1.binance.org:8545',
      'https://data-seed-prebsc-2-s1.binance.org:8545',
      'https://bsc-testnet.publicnode.com',
    ],
    blockExplorerUrls: ['https://testnet.bscscan.com'],
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
  },
};

export const ACTIVE_CHAIN = NETWORKS[ACTIVE_NETWORK];
export const ACTIVE_CHAIN_ID = ACTIVE_CHAIN.chainId;
